import React, { useState } from 'react';
import api from '../services/api';

// IN-PAGE ORDER CONFIRM (owner 2026-10-16: "not able to buy / place order from watchlist"). Browser pop-ups
// (window.confirm / window.prompt) are silently blocked in some phone browsers and installed apps, so the click
// did nothing and no order ever reached the server. This box asks for the quantity and sends the order to the
// user's OWN account in their current mode (paper or live) via /api/my/manual-order.
export default function OrderConfirm({ ask, onClose, onResult }) {
  const isOpt = !!ask.optType || /\d(CE|PE)$/i.test(String(ask.symbol || ''));
  const isLots = (ask.lotSize || 1) > 1 || isOpt;
  const [n, setN] = useState(ask.qty || 1);
  const [busy, setBusy] = useState(false);
  // MARKET or LIMIT at your own price (owner 2026-10-23); limit only for a specific contract / stock, not the AI CE/PE pick
  const [otype, setOtype] = useState('MARKET');
  const [lpx, setLpx] = useState(ask.price ? String(ask.price) : '');
  if (!ask) return null;
  const units = Math.max(1, n) * Math.max(1, ask.lotSize || 1);
  const send = async () => {
    setBusy(true);
    try {
      const res = ask.optType
        ? await api.myManualOptionOrder(ask.symbol, ask.optType, ask.side, Math.max(1, n))
        : await api.myManualOrder(ask.symbol, ask.exchange || 'NSE', ask.side, Math.max(1, n), ask.lotSize || 1,
          otype === 'LIMIT' ? (parseFloat(lpx) || 0) : 0);
      onResult(res && res.status === 'success' ? 'success' : 'error', (res && res.message) || (res && res.status === 'success' ? `${ask.side} done` : 'Order failed'));
    } catch (e) {
      onResult('error', 'Order failed — server not reachable');
    }
    setBusy(false);
    onClose();
  };
  const buy = ask.side === 'BUY';
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}
      onClick={onClose}>
      <div className="card" style={{ maxWidth: '360px', width: '100%', border: `1px solid ${buy ? '#00c46a' : '#ff4444'}` }} onClick={e => e.stopPropagation()}>
        <div style={{ fontWeight: 700, color: buy ? '#00ff88' : '#ff6b6b', marginBottom: '0.5rem' }}>
          {buy ? 'BUY' : 'SELL (close)'} {ask.optType ? `${ask.symbol} ${ask.optType}${buy ? ' (at-the-money)' : ''}` : (ask.label || ask.symbol)}
        </div>
        {buy && (
          <label style={{ display: 'block', fontSize: '0.85rem', color: '#ccc', marginBottom: '0.5rem' }}>
            {isLots && (ask.lotSize || 1) > 1 ? (
              // QUANTITY IN LOT STEPS (owner 2026-10-23: lot 500 -> 500, 1000, 1500 ...)
              <>Quantity:{' '}
                <input type="number" min={ask.lotSize} step={ask.lotSize} value={units} autoFocus
                  onChange={e => setN(Math.max(1, Math.round((parseInt(e.target.value, 10) || ask.lotSize) / ask.lotSize)))} style={{ width: '100px' }} />
                <span style={{ color: '#888' }}> = {Math.max(1, n)} lot{n > 1 ? 's' : ''} ({ask.lotSize} per lot)</span>
              </>
            ) : (<>{isLots ? 'Lots' : 'Shares'}:{' '}
              <input type="number" min="1" value={n} autoFocus onChange={e => setN(Math.max(1, parseInt(e.target.value, 10) || 1))} style={{ width: '80px' }} /></>)}
            {isLots && !((ask.lotSize || 1) > 1) && <span style={{ color: '#888' }}> (lot size taken from the contract)</span>}
          </label>
        )}
        {buy && !ask.optType && (
          <div style={{ display: 'flex', gap: '0.4rem', alignItems: 'center', flexWrap: 'wrap', marginBottom: '0.5rem', fontSize: '0.85rem', color: '#ccc' }}>
            <button className="btn" style={{ padding: '0.2rem 0.6rem', border: `1px solid ${otype === 'MARKET' ? '#00c46a' : '#444'}`, color: otype === 'MARKET' ? '#00ff88' : '#aaa', background: 'transparent' }}
              onClick={() => setOtype('MARKET')}>Market</button>
            <button className="btn" style={{ padding: '0.2rem 0.6rem', border: `1px solid ${otype === 'LIMIT' ? '#00c46a' : '#444'}`, color: otype === 'LIMIT' ? '#00ff88' : '#aaa', background: 'transparent' }}
              onClick={() => setOtype('LIMIT')}>Limit</button>
            {otype === 'LIMIT' && (<>
              <span>Buy price ₹</span>
              <input type="number" step="0.05" min="0" value={lpx} onChange={e => setLpx(e.target.value)} style={{ width: '90px' }} placeholder="price" />
            </>)}
          </div>
        )}
        {otype === 'LIMIT' && buy && <div style={{ fontSize: '0.75rem', color: '#ffb020', marginBottom: '0.4rem' }}>The order waits until the price reaches ₹{lpx || '…'} (cancel any time on the Dashboard; ends with the session).</div>}
        <div style={{ fontSize: '0.78rem', color: '#888', marginBottom: '0.7rem' }}>
          {buy ? 'Goes to YOUR account in your current mode (Paper or Live). The bot then manages the stop and exit.'
            : (ask.optType ? `Closes your open ${ask.symbol} ${ask.optType} position.` : 'Closes your open position in this contract.')}
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button className={buy ? 'btn btn-start' : 'btn btn-stop'} disabled={busy || (otype === 'LIMIT' && !(parseFloat(lpx) > 0))} onClick={send}>{busy ? 'Sending…' : (otype === 'LIMIT' && buy ? 'Place limit buy' : 'Confirm')}</button>
          <button className="btn" disabled={busy} onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
